import React, { useState, useRef, useEffect } from 'react';

// Reserves a 4:3 (400x300) gray placeholder box to avoid layout shift while the
// image loads lazily, then drops the reservation so the photo shows at its
// natural aspect ratio (no cropping).
const LazyImage = ({ className = '', ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.complete) setLoaded(true);
  }, []);

  return (
    <img
      ref={ref}
      loading='lazy'
      decoding='async'
      alt=''
      {...props}
      onLoad={() => setLoaded(true)}
      className={`${loaded ? '' : 'aspect-[4/3] bg-[#f0f0f0]'} ${className}`}
    />
  );
};

export default LazyImage;
